'use client';

import React, { memo } from 'react';

import { Sidebar } from './Sidebar';
import { useSidebar } from './SidebarProvider';
import { SidebarLayout } from './styles';

export const SidebarLayoutWrapper = memo(() => {
  const { isSidebarRendered, isSidebarOpened } = useSidebar();

  if (!isSidebarRendered) {
    return null;
  }

  return (
    <SidebarLayout isOpened={isSidebarOpened}>
      <Sidebar />
    </SidebarLayout>
  );
});

SidebarLayoutWrapper.displayName = 'SidebarLayoutWrapper';
